import React from 'react';
import Accordion from '@mui/material/Accordion';
import { Stack } from '@mui/material';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import CardComponent from './CardComponent';

const AccordionComponent = ({ title, cards, userRole, isCalendarCreated }) => {
  return (
    <Accordion
      defaultExpanded
      sx={{
        p: 1,
        borderRadius: '8px',
        backgroundColor: '#FBFCFE',
        boxShadow: '4px 0px 24px -2px #005CBC14',
        margin: '0px !important',
        '&:before': {
          display: 'none' // Remove the default top border
        },
        '&.Mui-expanded': {
          margin: '0px !important' // Remove margin when expanded
        }
      }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: 'rgba(58, 58, 58, 1)' }} />}
        aria-controls="panel1-content"
        id="panel1-header"
        sx={{
          margin: '0px !important'
        }}>
        <Stack direction="row" sx={{ width: '100%', justifyContent: 'space-between' }}>
          <Typography variant="h5" fontWeight="700" color="rgba(97, 97, 97, 1)">
            {title}
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          padding: '16px',
          width: '100%',
          height: 'auto'
        }}>
        <CardComponent cards={cards} userRole={userRole} isCalendarCreated={isCalendarCreated} />
      </AccordionDetails>
    </Accordion>
  );
};

export default AccordionComponent;
